<section>
    <div class="dashboard__maskinist" *ngIf="!this.auth.getUserInfo()?.adminuser">
        <h2 class="dashboard__heading" mdcHeadline2 *ngIf="maskinist">Hei, {{ maskinist.fornavn }}</h2>

        <div class="dashboard-group">
            <div class="dashboard__subgroup">
                <mdc-card class="card--saleslink">
                    <div class="card__header">
                        <h3 mdcHeadline4>Dagens forestillinger</h3>
                    </div>
                    <div class="card__content">
                        <ng-container *ngIf="mineforestillinger$ | async as maskinistdata; else forestillingerLaster">
                            <ng-container *ngFor="let ring of maskinistdata.ringer">
                                <div *ngIf="ring.forestillinger && ring.forestillinger.length">
                                    <h4 mdcBody1 class="text__medium-emphasis">{{ ring.forestillinger[0].spillested.navn }},
                                        {{ ring.forestillinger[0].spillested.stedsnavn }}</h4>
                                    <mdc-list interactive="false">
                                        <mdc-list-item *ngFor="let forestilling of ring.forestillinger">
                                            <div>{{ forestilling.tidspunkt }} {{ forestilling.film.norsktittel }}</div>
                                        </mdc-list-item>
                                    </mdc-list>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-template #forestillingerLaster>
                            <app-spinner [inline]="true"></app-spinner>
                        </ng-template>
                        <button [routerLink]="['/salg', 'kasse']" mdc-button raised>Gå til kasse</button>
                    </div>
                </mdc-card>
                <mdc-card>
                    <a href="{{hentBrukerveiledninglenke()}}" target="_blank">Bruksanvisning Kinologg – versjon oktober 2024</a>
                </mdc-card>
            </div>

            <mdc-card>
                <div class="card__header">
                    <h3 mdcHeadline4>Neste 7 jobber</h3>
                    <a routerLink="/kjoreplan">Se alle</a>
                </div>
                <div class="card__content">
                    <mdc-list interactive="false" *ngIf="kjoreplan?.length">
                        <mdc-list-item *ngFor="let item of kjoreplan">
                            <div class="list-item-text">{{ item.spillested.stedsnavn }}</div>
                            <div class="list-item-text">{{ item.dato | date:'d.M.yyyy' }}</div>
                        </mdc-list-item>
                    </mdc-list>
                    <p class="p__body" *ngIf="!kjoreplan?.length && !henterKjoreplan">Du har ingen kommende jobber.</p>
                    <app-spinner [inline]="true" *ngIf="!kjoreplan && henterKjoreplan"></app-spinner>
                </div>
            </mdc-card>

            <mdc-card>
                <div class="card__header">
                    <h3 mdcHeadline4>Kontaktinformasjon</h3>
                </div>
                <div class="card__content kontakt-container">
                    <div>
                        <h4 mdcHeadline5>Administrasjonen</h4>
                        <div class="kontakt" *ngFor="let k of kontaktAdm">
                            <h5 mdcHeadline6>{{ k.name }}</h5>
                            <p>{{ k.tittel }}</p>
                            <p *ngIf="k.telefon">Telefon: <a href="tel:{{ k.telefon }}">{{ k.telefon }}</a></p>
                            <p *ngIf="k.mobil">Mobil: <a href="tel:{{ k.mobil }}">{{ k.mobil }}</a></p>
                            <p *ngIf="k.email">E-post: <a href="mailto:{{ k.email }}">{{ k.email }}</a></p>
                        </div>
                    </div>
                    <div>
                        <h4 mdcHeadline5>Teknisk</h4>
                        <div class="kontakt" *ngFor="let k of kontaktTeknisk">
                            <h5 mdcHeadline6>{{ k.name }}</h5>
                            <p>{{ k.tittel }}</p>
                            <p *ngIf="k.telefon">Telefon: <a href="tel:{{ k.telefon }}">{{ k.telefon }}</a></p>
                            <p *ngIf="k.mobil">Mobil: <a href="tel:{{ k.mobil }}">{{ k.mobil }}</a></p>
                            <p *ngIf="k.email">E-post: <a href="mailto:{{ k.email }}">{{ k.email }}</a></p>
                        </div>
                    </div>
                </div>
            </mdc-card>
            <mdc-card class="card--maskinister">
                <div class="card__header">
                    <h3 mdcHeadline4>Maskinister</h3>
                </div>
                <div class="card__content" *ngIf="maskinister">
                    <mdc-data-table>
                        <table mdcDataTableTable>
                            <thead>
                                <tr mdcDataTableHeaderRow>
                                    <td mdcDataTableHeaderCell>Navn</td>
                                    <td mdcDataTableHeaderCell numeric>Telefon</td>
                                    <td mdcDataTableHeaderCell>Epost</td>
                                    <td mdcDataTableHeaderCell>Adresse</td>
                                </tr>
                            </thead>
                            <tbody MDCDataTableContent>
                                <tr mdcDataTableRow *ngFor="let m of maskinister">
                                    <td mdcDataTableCell>{{ m.navn }}</td>
                                    <td mdcDataTableCell numeric>{{ m.telefon1 }}</td>
                                    <td mdcDataTableCell>{{ m.epost }}</td>
                                    <td mdcDataTableCell>{{ m.postadr }}, {{ m.postnr }} {{ m.poststed }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </mdc-data-table>
                </div>
            </mdc-card>
        </div>
    </div>
</section>